<!--
  File: UserList.vue
  Icons: materialdesignicons.com
-->

<template>
  <v-container fluid>
    <v-row>
      <v-col sm="12" md="6" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">        
        <v-card outlined style="width: 100%">
          <v-toolbar class="elevation-0" color="background">
            <v-toolbar-title>{{title}}</v-toolbar-title>
          </v-toolbar>
          <v-row class="pa-3 mb--40" align="center">
            <v-col cols="4">
              <v-select class="font-14" v-model="level" :items="levels" label="회원구분" @change="refresh()" />
            </v-col>
            <v-col cols="3"><v-select class="font-14" v-model="type" :items="types" label="찾기" /></v-col>
            <v-col cols="3"><v-text-field class="font-14" v-model="keyword" @keyup.13.stop.prevent="search()" /></v-col>
            <v-col cols="2" md="1" class="text-right"><v-icon @click="search()">mdi-magnify</v-icon></v-col>
            <v-col cols="1" v-if="$vuetify.breakpoint.mdAndUp">
              <v-icon @click="refresh(login.level == 5 ? -1 : 5)">mdi-refresh</v-icon>
            </v-col>
          </v-row>
          
          <v-row class="pl-3 pr-3" >
            <v-divider />
          </v-row>
          
          <v-row v-if="users.length == 0" class="pa-3">
            <v-col cols="12" class="text-center">조건에 해당되는 내용이 없습니다.</v-col>
          </v-row>

          <v-list class="pt-3">
            <v-list-item class="pa-0" v-for="(user, i) in users.slice(offset, offset + 10)" :key="i" @click="setUserInfo(user)">
              <v-col cols="4">{{user.name}}
                <span v-if="user.nick && $vuetify.breakpoint.mdAndUp" class="accent--text pl-1">{{user.nick}}</span>
                <v-icon v-if="isNewMember(user)" color="red">mdi-new-box</v-icon>
              </v-col>
              <v-list-item-subtitle v-text="user.email" class="mr-3"/>
              <v-list-item-subtitle v-text="util.getPhoneNumber(user.mobile)"/>
            </v-list-item>
          </v-list>

          <v-row v-if="pages == 1" class="pa-3" />
          <v-row v-if="pages >= 2" class="pa-3"><v-divider /></v-row>
          <v-row v-if="pages >= 2" class="ma-3" justify="center">
            <v-pagination circle v-model="page" :length="pages" @input="move()" />
          </v-row>

          <div v-if="$vuetify.breakpoint.smAndDown" class="width-800" />

        </v-card>
        <v-row v-if="edit == null" class="pa-3" align="center">
          <v-col cols="6"><v-btn color="primary" elevation="0" @click="add()">추가</v-btn></v-col>
          <v-col cols="6" v-if="users.length > 0" class="text-right">{{users.length}}명</v-col>
        </v-row>
      </v-col>

      <v-col sm="12" md="6" v-if="user && userCoupons == null" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
        <v-card outlined>
          <v-toolbar class="mb-6 elevation-0" color="background">
            <v-toolbar-title>{{subtitle}}</v-toolbar-title>
          </v-toolbar>

          <v-row class="pl-3 pr-3" v-for="(info, i) in userInfo" :key="i" align-top>

            <v-col cols="1"><v-icon>{{info.icon}}</v-icon></v-col>
            <v-col cols="3" class="font-weight-light">{{info.title}}</v-col>            
            <v-col cols="8"
              v-if="(edit == null && i != 7 && i != 8) || i == 2 || i == 3 || i == 5 || i == 6">
              {{info.text}}
            </v-col>
            <v-col cols="8" v-if="i == 7">
              {{info.text}} <a class="ml-2 font-weight-bold" @click="getUserCoupons()">쿠폰관리</a>
            </v-col>

            <v-col cols="8" v-if="edit == null && i == 8">
              <a :href="'tel:' + info.text">{{info.text}}</a>
            </v-col>

            <v-col cols="8" v-if="edit && i == 0" class="mt--20 mb--20">
              <v-select v-model="edit.studio" :items="studios" />
            </v-col>

            <v-col cols="8" v-if="edit && i == 1" class="mt--20 mb--20">
              <v-select v-model="edit.level" :items="levels" />
            </v-col>

            <v-col cols="8" v-if="edit && i == 4" class="pt-1 pb-0 mt--10">
              <v-row class="pa-0">
                <v-col class="pr-1"><v-text-field v-model="edit.name" /></v-col>
                <v-col class="pl-1"><v-text-field v-model="edit.nick" /></v-col>
              </v-row>
            </v-col>

            <v-col cols="8" v-if="edit && i == 8" class="pt-1 pb-0">
              <v-text-field class="pt-0 pb-0" v-model="edit.mobile" />
            </v-col>

            <v-col cols="8" v-if="edit && i == 9" class="pt-1 pb-0">
              <v-text-field class="pt-0 pb-0" v-model="edit.address" />
              <v-text-field class="pt-0 pb-0 mt--10" v-model="edit.address2" />
            </v-col>

            <v-col cols="8" v-if="edit && i == 10" class="pt-1 pb-0">
              <v-textarea class="pt-0 pb-0" v-model="edit.memo" rows="1" counter auto-grow />
            </v-col>
            
          </v-row>
          <v-spacer class="pa-3"/>
          <v-divider />
          <v-row class="pa-3" align="center" justify="end">
            <v-col class="text-left" v-if="edit == null">
              <v-btn color="accent" elevation="0" @click="remove()">삭제</v-btn>
              <v-btn color="primary ml-3" elevation="0" @click="modify()">수정</v-btn>
            </v-col>
            <v-col class="text-right" v-if="edit == null">
              <v-btn color="primary" elevation="0" @click="getHistory()">예약 이력</v-btn>
            </v-col>
            <v-col class="text-right" v-if="edit">
              <v-btn color="normal" elevation="0" @click="cancel()" class="mr-3">취소</v-btn>
              <v-btn color="secondary" elevation="0" @click="update()">적용</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col sm="12" md="6" v-if="user && userCoupons" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
        <v-card outlined>
          <v-toolbar class="mb-3 elevation-0" color="background">
            <v-toolbar-title>{{user.name}} ({{user.email}})님의 쿠폰 정보</v-toolbar-title>
          </v-toolbar>
          <v-row class="ma-1">
            <v-col cols="3" md="2">쿠폰명</v-col>
            <v-col cols="4" v-if="$vuetify.breakpoint.mdAndUp">발행일<span class="pl-16">갯수</span></v-col>
            <v-col cols="4" md="3">유효기간</v-col>
            <v-col cols="2" v-if="$vuetify.breakpoint.smAndDown">발행</v-col>
            <v-col cols="3" class="text-right pr-7">남은갯수</v-col>
          </v-row>
          <v-divider />
          <v-row class="pa-3" v-if="userCoupons.length == 0">
            <v-col class="text-center" cols="12">쿠폰이 없습니다.</v-col>
          </v-row>
          <v-row :class="'ma-1 ' + color(item)" v-for="(item, i) in userCoupons" :key="i">
            <v-col cols="3" md="2" v-if="item.id">{{util.getItem(couponTypes, item.coupon_type).text}}</v-col>
            <v-col cols="4" v-if="item.id && $vuetify.breakpoint.mdAndUp">
              {{util.getDate(new Date(item.cdate))}}<span class="pl-6">{{item.total}}</span>
            </v-col>
            <v-col cols="4" md="3" v-if="item.id">{{util.getDate(new Date(item.expired))}}</v-col>
            <v-col cols="2" v-if="item.id && $vuetify.breakpoint.smAndDown">{{item.total}}</v-col>
            <v-col cols="3" v-if="item.id" class="text-right">{{item.remain}}
              <a class="pl-3 blue--text"
                v-if="!isAdding() && item.remain > 0 && i > 0 && userCoupons[0].days >= 0"
                @click="forward(item, userCoupons[0])">이월</a>
              <a class="pl-3 grey--text"
                v-if="!isAdding() && (item.remain == 0 || i == 0 || userCoupons[0].days < 0)"
                @click="deleteCoupon(item)">삭제</a>
            </v-col>
            
            <v-col cols="3" v-if="item.id == null" class="mt--20 mb--20">
              <v-select v-model="item.coupon_type" :items="couponTypes" />
            </v-col>
            <v-col cols="4" v-if="item.id == null" class="pt-1 pb-0">
              <v-text-field class="pt-0 pb-0" v-model="item.expired" type="date" />
            </v-col>
            <v-col cols="2" v-if="item.id == null" class="pt-1 pb-0">
              <v-text-field class="pt-0 pb-0" v-model="item.total" type="number" @input="item.remain = item.total"/>
            </v-col>
            <v-col cols="2" v-if="item.id == null" class="pt-1 pb-0">
              <v-text-field class="pt-0 pb-0" v-model="item.remain" type="number" disabled />
            </v-col>
          </v-row>
          <v-spacer class="pa-3"/>
          <v-divider />
          <v-row class="pa-3" align="center" justify="end">
            <v-col class="text-right" v-if="!isAdding()">
              <v-btn color="primary" elevation="0" @click="addCoupon()">추가</v-btn>
            </v-col>
            <v-col class="text-right" v-if="isAdding()">
              <v-btn color="normal" @click="addCancel()" class="mr-3 elevation-0">취소</v-btn>
              <v-btn color="secondary" elevation="0" @click="insertCoupon()">확인</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      
      <v-col sm="12" md="6" v-if="history" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
        <v-card outlined>
          <v-toolbar class="mb-6 elevation-0" color="background">
            <v-toolbar-title>{{title2}}</v-toolbar-title>
          </v-toolbar>

          <v-row v-if="history.length > 0" class="pl-3 pb-3">
            <v-col cols="5" md="3">수업일시</v-col>
            <v-col cols="4" md="3" class="text-truncate">수업명</v-col>
            <v-col cols="4" v-if="$vuetify.breakpoint.mdAndUp">예약일시</v-col>
            <v-col cols="3" md="2">강사</v-col>
          </v-row>
          <v-divider class="pb-3" v-if="history.length > 0" />

          <div v-if="history.length == 0" class="text-center pb-6 accent--text">예약 이력이 없습니다.</div>

          <v-row class="pl-3" v-for="(info, i) in history.slice(offset2, offset2 + 10)" :key="i" align-top>
            <v-col cols="5" md="3">{{info.date}} {{info.time}}</v-col>
            <v-col cols="4" md="3" class="text-truncate font-weight-light">{{info.lesson}}</v-col>
            <v-col cols="4" v-if="$vuetify.breakpoint.mdAndUp">{{info.booking_date}}</v-col>
            <v-col cols="3" md="2" class="text-truncate font-weight-light">{{info.instructor}}</v-col>
          </v-row>
          
          <v-row v-if="pages2 == 1" class="pa-3" />
          <v-row v-if="pages2 >= 2" class="pa-3"><v-divider /></v-row>
          <v-row v-if="pages2 >= 2" class="ma-3" justify="center">
            <v-pagination circle v-model="page2" :length="pages2" @input="offset2 = (page2 - 1) * 10" />
          </v-row>
        </v-card>
        <v-row v-if="history.length > 0" class="pa-3" align="center">
          <v-col cols="12" class="text-right">{{history.length}}개</v-col>
        </v-row>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import util from '../utils/util'

export default {
  data () {
    return {
      login: null,
      edit: null,
      user: null,
      users: [],
      title: null,
      subtitle: null,
      studio: 0,
      studios: [],
      level: -1,
      levels: [],
      couponTypes: [],
      type: '성명',
      types: [
        '성명',
        '아이디',
        '전화번호',
      ],
      userId: '',
      userInfo: [
        { icon: 'mdi-map-marker', title: '스튜디오', text: '' },
        { icon: 'mdi-wallet-membership', title: '회원구분', text: '' },
        { icon: 'mdi-account', title: '아이디', text: ''},
        { icon: 'mdi-calendar-plus', title: '가입일', text: '' },
        { icon: 'mdi-tag', title: '성명', text: '' },
        { icon: 'mdi-human-male-female', title: '성별', text: '' },
        { icon: 'mdi-cake-variant', title: '생년월일', text: '' },
        { icon: 'mdi-ticket', title: '보유쿠폰', text: '' },
        { icon: 'mdi-cellphone', title: '전화번호', text: '' },
        { icon: 'mdi-home', title: '주소', text: '' },
        { icon: 'mdi-note', title: '메모', text: '' }
      ],
      page: 1,
      pages: 0,
      offset: 0,
      keyword: '',
      userCoupons: null,
      
      title2: null,
      history:null,
      page2: 1,
      pages2: 0,
      offset2: 0,

      util: util
    }
  },

  props: {
    source: String,
  },

  methods: {
    move: function () {
      this.offset = (this.page - 1) * 10
    },

    refresh: function (level) {
      if (level != null) this.level = level
      this.keyword = ''
      this.getUserList(this.login.studio, this.level)
    },

    search: function () {
      this.level = -1
      this.getUserList(this.login.studio, this.level, this.types.indexOf(this.type), this.keyword)
    },

    getUserList: function (studio, level, search, keyword) {
      this.user = null
      let url = `/api/user/list/${studio}/${level}/0/1000`
      if (keyword) {
        url = `/api/user/find/${studio}/?search=${search}&keyword=${keyword}`
      }
      axios.get(url)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else {
          this.users = response.data.list
          this.pages = Math.ceil(this.users.length / 10)
          this.page = 1
          this.move()
        }
      })
    },

    isNewMember: function (user) {
      let diff = new Date - new Date(user.cdate)
      let days = diff / (3600 * 24 * 1000)
      return days < 7
    },

    setUserInfo: function (user) {
      this.subtitle = '정보 보기'
      this.edit = null
      this.user = user
      this.userCoupons = null
      this.history = null
      this.userInfo[0].text = util.getItem(this.studios, user.studio).text
      this.userInfo[1].text = util.getItem(this.levels, user.level).text
      this.userInfo[2].text = user.email
      this.userInfo[3].text = user.cdate.split('T')[0]
      this.userInfo[4].text = user.name + (user.nick ? (' (' + user.nick.replace(/[()]/gi, '') + ')') : '')
      this.userInfo[5].text = user.sex ? (user.sex == 1 ? '남성' : '여성') : '알 수 없음'
      this.userInfo[6].text = user.birth ? user.birth : '알 수 없음'
      util.getUserCoupon(user.id, text => { this.userInfo[7].text = text })
      this.userInfo[8].text = util.getPhoneNumber(user.mobile)
      this.userInfo[9].text =(user.address ? user.address : '') + (user.address2 ? ' ' + user.address2 : '')
      this.userInfo[10].text = user.memo
    },

    add: function () {
      this.$router.push('/signup')
    },

    color: function(item) {
      return item.days < 0 || item.remain == 0 ? 'grey--text' : 'black--text'
    },

    isAdding: function () {
      return this.userCoupons.length && this.userCoupons[0].id == null
    },

    modify: function () {
      this.subtitle = '정보 수정'
      this.edit = JSON.parse(JSON.stringify(this.user))
      this.edit.mobile = util.getPhoneNumber(this.edit.mobile)
      if (this.user.nick == null) this.edit.nick = ''
      if (this.user.address == null) this.edit.address = ''
      if (this.user.address2 == null) this.edit.address2 = ''
      if (this.user.memo == null) this.edit.memo = ''
    },

    cancel: function () {
      this.setUserInfo(this.user)
    },

    update: function () {
      if (this.edit.name.trim().length < 2) return
      if (this.edit.mobile.trim().length < 10) return

      let params = new URLSearchParams()
      params.append('id', this.user.id)
      params.append('email', this.user.email)
      params.append('name', this.edit.name)
      params.append('nick', this.edit.nick ? this.edit.nick : '')
      params.append('mobile', this.edit.mobile ? this.edit.mobile : '')
      params.append('address', this.edit.address ? this.edit.address : '')
      params.append('address2', this.edit.address2 ? this.edit.address2 : '')
      params.append('memo', this.edit.memo)
      params.append('studio', this.edit.studio)
      params.append('level', this.edit.level)

      axios.post('/api/user/update', params, util.headers)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else {
          this.user.name = response.data.user.name
          this.user.nick = response.data.user.nick
          this.user.mobile = response.data.user.mobile
          this.user.address = response.data.user.address
          this.user.address2 = response.data.user.address2
          this.user.memo = response.data.user.memo
          this.user.studio = response.data.user.studio
          this.user.level = response.data.user.level
          this.setUserInfo(this.user)
        }
      })
    },

    remove: function () {
      if (!confirm(this.user.name + '님을 정말로 삭제하시겠습니까?')) {
        return
      }
      let params = new URLSearchParams()
      params.append('id', this.user.id)
      params.append('email', this.user.email)
      params.append('from', this.login.id)
      axios.post('/api/user/delete', params, util.headers)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else {
          let index = this.users.map(user => { return user.id }).indexOf(this.user.id)
          if (index >= 0) {
            this.users.splice(index, 1)
            this.user = null
          }
        }
      })
    },
    
    getUserCoupons: function () {
      axios.get(`/api/coupon/user/${this.user.id}`)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else {
          this.userCoupons = []
          response.data.coupons.forEach(coupon => {
            if (this.userCoupons.length < 10)
              this.userCoupons.push(coupon)
          })
        }
      })
    },
    
    addCoupon: function () {
      this.userCoupons.unshift({
        user: this.user.id,
        coupon_type: 2,
        issued: util.getDate(new Date),
        expired: util.getDate(new Date, 60),
        days: 60,
        remain: 20,
        total: 20
      })
    },

    addCancel: function () {
      if (this.isAdding()) {
        this.userCoupons.shift()
      }
    },

    insertCoupon: function () {
      if (this.userCoupons.length == 0) return
      let coupon = this.userCoupons[0]
      if (coupon.total < 0) return

      let params = new URLSearchParams()
      params.append('user', coupon.user)
      params.append('coupon_type', coupon.coupon_type)
      params.append('issued', util.getDate(new Date))
      params.append('expired', coupon.expired)
      params.append('total', coupon.total)
      params.append('remain', coupon.remain)
      params.append('from', this.login.id)
      axios.post(`/api/coupon/user/insert`, params, util.headers)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else this.getUserCoupons()
      })
    },
    
    deleteCoupon: function (coupon) {
      let date = util.getDate(new Date(coupon.cdate))
      let name = `${coupon.name} (${coupon.total} / ${coupon.remain})`
      if (!confirm(`${this.user.name}님의 ${date} 발행된 ${name}를 삭제하시겠습니까?`)) {
        return
      }
      let params = new URLSearchParams()
      params.append('id', coupon.id)
      params.append('user', coupon.user)
      params.append('from', this.login.id)
      axios.post(`/api/coupon/user/delete`, params, util.headers)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else if (response.data.result == 'success') {
          this.getUserCoupons()
        }
      })
    },

    forward: function (prev, curr) {
      if (curr.id == null) return

      let date = util.getDate(new Date(prev.cdate))
      let text = `${prev.name} (${prev.remain}개)`
      if (!confirm(`${this.user.name}님의 ${date} 발행된 ${text}를 최근 발행된 쿠폰으로 이월하시겠습니까?`)) {
        return
      }

      let params = new URLSearchParams()
      params.append('user', prev.user)
      params.append('coupon', prev.id)
      params.append('count', prev.remain)
      params.append('coupon_to', curr.id)
      params.append('from', this.login.id)
      axios.post(`/api/coupon/user/forward`, params, util.headers)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else if (response.data.result == 'success') {
          this.getUserCoupons()
        }
        else {
          alert('쿠폰을 이월할 수 없습니다.')
        }
      })
    },
    
    getHistory: function () {
      let query = `/api/booking/history/${this.user.id}`
      axios.get(query)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else {
          this.title2 = `${this.user.name} (${this.user.email})님의 예약 이력`
          this.user = null
          this.history = response.data.list
          this.pages2 = Math.ceil(this.history.length / 10)
          this.page2 = 1
          this.offset2 = 0
        }
      })
    }
  },

  created () {
    console.clear()
    let json = localStorage.getItem('login')
    if (json) {
      this.login = JSON.parse(json)
    }
    if (this.login) {
      if (this.login.level == 5) {
        this.title = '회원 관리'
      }
      if (this.login.level == 10) {
        this.title = '스튜디오 운영자 관리'
      }
      
      this.$emit('login', this.login)

      util.getStudios((studios, error) => {
        if (error) console.log(error)
        this.studios = studios.slice(1, studios.length)

        util.getLevels((levels, error) => {
          if (error) console.log(error)
          this.levels = levels
          this.levels.unshift({ value: -1, text: '전체' })

          util.getCouponTypes((couponTypes, error) => {
            if (error) console.log(error)
            this.couponTypes = couponTypes

            this.refresh(this.login.level == 5 ? -1 : 5)
          })
        })
      })
    }
    else {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.mt--10 {
    margin-top: -10px;
}
.mt--20 {
    margin-top: -20px;
}
.mb--20 {
    margin-bottom: -20px;
}
.mb--40 {
    margin-bottom: -40px;
}
.font-14 {
  font-size: 14px;
}
.width-800 {
  width: 800px;
}
</style>
